export default __webpack_public_path__ + "static/media/cart-filled.cf69d93e.svg";